/**
 * Form-field keys for the single, module-wide Preferences form. These are the
 * Formik value keys (not necessarily the API field names): some settings need
 * a transform on save (minutes ⇄ seconds, CSV ⇄ string[], complaint channel
 * split into channel + email + phone). Serialization lives in `serialize.ts`.
 */
export const PREFERENCES_FIELDS_NAME = {
  // Operación
  DEPOSIT_SERVICE_TIME: 'depositServiceTime',
  VISIT_SERVICE_TIME: 'visitServiceTime',
  ALERT_ASSIGN_DRIVER_TIME: 'alertAssignDriverTime',
  ALERT_BEGIN_ROUTE_TIME: 'alertBeginRouteTime',
  CARRIER_CAN_MODIFY_ITEMS: 'carrierCanModifyItems',

  // Pedidos y carga
  UNIT_1_CAPACITY_TYPE_ID: 'unit1CapacityTypeId',
  UNIT_2_CAPACITY_TYPE_ID: 'unit2CapacityTypeId',
  USE_VOLUMETRIC_WEIGHT: 'useVolumetricWeight',
  VOLUMETRIC_WEIGHT_CAPACITY_FACTOR: 'volumetricWeightCapacityFactor',
  VOLUMETRIC_WEIGHT_THRESHOLD: 'volumetricWeightThreshold',
  AUTO_SUM_ITEM_TASK_CASH: 'autoSumItemTaskCash',
  AUTO_SUM_ITEM_TASK_UNIT_1: 'autoSumItemTaskUnit1',
  AUTO_SUM_ITEM_TASK_UNIT_2: 'autoSumItemTaskUnit2',
  SERVICE_TYPE_LIST: 'serviceTypeList',
  SKILLS_LIST: 'skillsList',

  // Etiquetas y documentos
  ZEBRA_MODE_IN_TICKET_PDF: 'zebraModeInTicketPdf',
  INCLUDE_DIE_IN_TICKET_PDF: 'includeDieInTicketPdf',
  ONE_TICKET_BY_ARTICLE: 'oneTicketByArticle',
  ROADMAP_COLUMNS_LIST: 'roadmapColumnsList',
  REPORT_FORMAT_TYPE_ID: 'reportsFormatTypeId',

  // App de choferes
  ALLOW_NEW_ROUTES_MOBILE: 'allowNewRoutesMobile',
  DRIVER_PERMISSION_ALLOW_NEW_ITEMS: 'driverPermissionAllowNewItems',
  DRIVER_PERMISSION_ALLOW_DELIVERY_COLLECT:
    'driverPermissionAllowDeliveryCollect',
  DRIVER_PERMISSION_ALLOW_REOPTIMIZE_ROUTES:
    'driverPermissionAllowReoptimizeRoutes',
  DRIVER_PERMISSION_IMAGE_LIBRARY: 'driverPermissionImageLibrary',
  DRIVER_PERMISSION_ROUTE_HISTORY: 'driverPermissionRoutesHistory',
  DRIVER_PERMISSION_BLOCK_ITEM_TASKS: 'driverPermissionBlockItemTasks',
  ASK_DRIVER_TO_CONFIRM_ARRIVAL: 'askDriverToConfirmArrival',
  MANDATORY_LOAD_CONTROL: 'mandatoryLoadControl',
  PREVENT_MISSING_ITEMS_ON_ROUTE: 'preventMissingItemsOnRoute',
  ALLOW_LOAD_UNSCHEDULED_ITEMS: 'allowLoadUnscheduledItems',
  SHOW_ONLY_REQUIRED_FIELDS: 'showOnlyRequiredFieldsDeliveryEvidence',
  FEEDBACK_REQUEST_SIGN: 'feedbackRequestSign',
  FEEDBACK_REQUEST_RECEPTOR_NAME: 'feedbackRequestReceptorName',
  FEEDBACK_REQUEST_RECEPTOR_ID: 'feedbackRequestReceptorId',
  FEEDBACK_REQUEST_DOCUMENTATION: 'feedbackRequestDocs',
  FEEDBACK_REQUEST_PICTURE: 'feedbackRequestPicture',
  FEEDBACK_REQUEST_NOTES: 'feedbackRequestNotes',
  FEEDBACK_REQUEST_AUDIT: 'feedbackRequestAudit',
  FEEDBACK_REQUEST_PICTURE_ON_REJECTED: 'feedbackRequestPictureOnRejected',
  FEEDBACK_REQUEST_NOTES_ON_REJECTED: 'feedbackRequestNotesOnRejected',
  FEEDBACK_REQUEST_REJECTED_REASON: 'feedbackRequestRejectedReason',
  SHOW_AS_NEW_ON_REJECTED: 'showAsNewOnRejected',
  MAX_REVISIT_COUNT: 'maxRevisitCount',
  REVISIT_EXHAUSTED_REASON_TYPE: 'revisitExhaustedReasonType',
  REVISIT_EXHAUSTED_REJECTED_REASON: 'revisitExhaustedRejectedReason',
  REVISIT_EXHAUSTED_CUSTOM_REASON: 'revisitExhaustedCustomReason',
  UNASSIGN_DRIVER_ON_FORCED_CLOSURE: 'unassignDriverOnForcedClosure',
  AUTO_COMPLETE_WITH_ML: 'autocompleteWithMl',
  AUTO_FULLFILL_WITH_ML: 'autoFullfillWithMl',

  // Experiencia del cliente
  SHOW_TRACKING_MAP: 'showTrackingMap',
  COMPLAINT_CHANNEL_TYPE: 'complaintChannelType',
  COMPLAINT_EMAIL: 'complaintEmail',
  COMPLAINT_PHONE: 'complaintPhone',
  ALLOW_USER_DOWNLOAD_EVIDENCE: 'allowUsersDownloadEvidencePdf',
  INCLUDE_MAP_IN_EVIDENCE: 'includeMapEvidencePdf',
  SHOW_ITEMTASK_ON_EVIDENCE_PDF: 'showItemTasksOnEvidencePdf',
  SEND_ETA_TO_CUSTOMERS: 'sendEtatoCustomers',
  TRACKING_MAIL_IN_DELIVERY_ENABLED: 'trackingMailInDeliveryEnabled',
  TRACKING_MAIL_IN_DELIVERY: 'trackingMailInDeliveryBody',
  TRACKING_MAIL_IN_PROGRESS_ENABLED: 'trackingMailInProgressEnabled',
  TRACKING_MAIL_IN_PROGRESS: 'trackingMailInProgressBody',
  TRACKING_MAIL_IN_DELIVERY_SUCCESS_ENABLED:
    'trackingMailInDeliverSuccessEnabled',
  TRACKING_MAIL_IN_DELIVERY_SUCCESS: 'trackingMailInDeliverSuccessBody',
  TRACKING_MAIL_IN_DELIVERY_FAIL_ENABLED: 'trackingMailInDeliverFailEnabled',
  TRACKING_MAIL_IN_DELIVERY_FAIL: 'trackingMailInDeliverFailBody',
  TRACKING_WA_IN_DELIVERY_ENABLED: 'trackingWainDeliveryEnabled',
  TRACKING_WA_IN_PROGRESS_ENABLED: 'trackingWainProgressEnabled',
  TRACKING_WA_ON_THE_WAY_ENABLED: 'trackingWaonTheWayEnabled',
  TRACKING_WA_IN_DELIVERY_SUCCESS_ENABLED: 'trackingWainDeliverSuccessEnabled',
  TRACKING_WA_IN_DELIVERY_FAIL_ENABLED: 'trackingWainDeliverFailEnabled',

  // Comercial
  BILLING_LIST_ID: 'billingListId',
  CUSTOMER_TYPE_LIST: 'customerTypeList',
} as const;

/** Options for the report-format select (Etiquetas y documentos → Reportes). */
export const REPORT_FORMAT_TYPE = ['CSV', 'EXCEL'];
